"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _changePhone = require("./changePhone");
Object.keys(_changePhone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changePhone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changePhone[key];
    }
  });
});
var _sendValidationCode = require("./sendValidationCode");
Object.keys(_sendValidationCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendValidationCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendValidationCode[key];
    }
  });
});
var _registerOrAuthorize = require("./registerOrAuthorize");
Object.keys(_registerOrAuthorize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _registerOrAuthorize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _registerOrAuthorize[key];
    }
  });
});
var _authenticateByToken = require("./authenticateByToken");
Object.keys(_authenticateByToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _authenticateByToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authenticateByToken[key];
    }
  });
});
var _registerOrAuthorizeByToken = require("./registerOrAuthorizeByToken");
Object.keys(_registerOrAuthorizeByToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _registerOrAuthorizeByToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _registerOrAuthorizeByToken[key];
    }
  });
});
var _checkPhone = require("./checkPhone");
Object.keys(_checkPhone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkPhone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkPhone[key];
    }
  });
});
var _autosubmitEnabled = require("./autosubmitEnabled");
Object.keys(_autosubmitEnabled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _autosubmitEnabled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _autosubmitEnabled[key];
    }
  });
});